import { useState, useEffect } from 'react';

const AchievementNotification = ({ achievement, onDismiss }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [shouldRender, setShouldRender] = useState(true);

  // Animation entry effect
  useEffect(() => {
    // Start the entry animation after component mounts
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);
    
    return () => clearTimeout(timer);
  }, []);

  // ADD THIS: Auto-dismiss after 5 seconds
  useEffect(() => {
    const dismissTimer = setTimeout(() => {
      handleDismiss();
    }, 7000); 
    
    return () => clearTimeout(dismissTimer);
  }, []);

  // Handle dismiss with animation
  const handleDismiss = () => {
    setIsVisible(false);
    
    // Wait for animation to complete before calling the actual onDismiss
    setTimeout(() => {
      setShouldRender(false);
      onDismiss();
    }, 300); // Match this timing with the transition duration
  };

  if (!shouldRender) return null;

  return (
    <div 
      className={`fixed bottom-8 right-8 w-80 bg-gradient-to-r from-indigo-500 to-purple-500
                 text-white rounded-lg shadow-lg z-100 transition-transform duration-300 ease-in-out
                 ${isVisible ? 'translate-x-0' : 'translate-x-full'}`}
                 style={{ color: 'white' }} 
    >
      <div className="relative p-3 pt-3">
        {/* Close button positioned at top right */}
        <button
          onClick={handleDismiss}
          className="absolute top-1 right-1 text-black bg-white rounded-md"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
       
        <div className="pr-3 text-white">
          {/* Header row with Achievement Unlocked text and ribbon icon */}
          <div className="flex items-center mb-1">
            <div className="flex-shrink-0 relative text-yellow">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-9 w-9 text-yellow-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="8" r="7"></circle>
                <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>
              </svg>
            </div>
            <div> 
            <div className="text-sm mx-2">Achievement Unlocked! </div>
              <div className="text-4xl font-bold mx-2">{achievement.name}</div>
              
            </div>
          </div>
         
          {/* Achievement details */}
          
          <div className="text-md"> {achievement.description}</div>
        </div>
       
        {/* View All Achievements button */}
        <div className="pt-2">
          <button
            onClick={() => window.location.href = '/manageAccount#achievements'}
            className="w-full py-1.5 bg-purple-700 hover:bg-purple-800 rounded text-sm font-medium transition-colors text-white"
          >
            View All Achievements
          </button>
        </div>
      </div>
    </div>
  );
};

export default AchievementNotification;